var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-select',{style:({ width: "100%" }),attrs:{"value":_vm.value,"multiple":"","placeholder":_vm.placeholder || ""},on:{"input":($event) => _vm.$emit("input", $event)}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.title,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }